import React, { useState } from 'react';
import BordResponsibleUserSearchDropdown from './BordResponsibleUserSearchDropdown/BordResponsibleUserSearchDropdown';
import PlusButton from '../../../assets/images/searchBar/plusButton';
import BordResponsibleUserPictures from './BordReponsibleUserPictures/BordResponsibleUserPictures';
import { IbackofficeUserData } from '../../../types/configuration.types';
import { IResponsibleUserData } from '../../../types/responsibleUser.types';
import './BordResponsibleUser.scss';

/**
 * Componente para gestionar responsables: muestra botón/foto, permite buscar y asignar responsables.
 * @param orderId Id de la orden.
 * @param allUsersList Lista de empleados disponibles.
 * @param logisticServiceId Id del servicio logístico.
 * @param responsibleUsersList Responsables asignados.
 * @param handleAssignResponsible Función para asignar un responsable.
 * @param handleDeleteResponsible Función para eliminar un responsable.
 * @param isLoading Booleano para indicar si se está cargando.
 * @param showResponsibleUsersSkeletonLoader Booleano para indicar si se debe mostrar el skeleton loader.
 */
const BordResponsibleUser: React.FC<BordResponsibleUserProps> = ({
  orderId,
  allUsersList,
  logisticServiceId,
  responsibleUsersList,
  handleAssignResponsible,
  handleDeleteResponsible,
  isLoading,
  showResponsibleUsersSkeletonLoader
}) => {
  const [showSearchDropdown, setShowSearchDropdown] = useState<boolean>(false);

  const handleToggleSearchDropdown = () => setShowSearchDropdown(showSearchDropdown => !showSearchDropdown);

  if (showResponsibleUsersSkeletonLoader) return <div className="bordResponsibleUserSkeletonLoader animationLoader" />;

  return (
    <div className="bordResponsibleUser">
      <div
        className={`addResponsiblesButton${showSearchDropdown ? ' active' : ''}`}
        onClick={handleToggleSearchDropdown}
      >
        {!!responsibleUsersList.length && (
          <BordResponsibleUserPictures responsibleUsersList={responsibleUsersList} hideDropdown={showSearchDropdown} />
        )}

        <span>{responsibleUsersList.length > 0 ? 'Agregar más responsables' : 'Agregar responsables'}</span>

        <PlusButton className="plusButtonIcon" />
      </div>

      {showSearchDropdown && (
        <BordResponsibleUserSearchDropdown
          users={allUsersList || []}
          responsibleUsersList={responsibleUsersList}
          handleAssignResponsible={handleAssignResponsible}
          handleDeleteResponsible={handleDeleteResponsible}
          handleCloseDropdown={() => setShowSearchDropdown(false)}
          isLoading={isLoading}
          logisticServiceId={logisticServiceId}
          orderId={orderId}
        />
      )}
    </div>
  );
};

export default BordResponsibleUser;

export interface BordResponsibleUserProps {
  orderId?: number | null;
  isLoading?: boolean;
  allUsersList?: IbackofficeUserData[];
  logisticServiceId?: number | null;
  responsibleUsersList: IResponsibleUserData[];
  handleAssignResponsible: (user: IbackofficeUserData) => Promise<void>;
  handleDeleteResponsible: (responsibleId?: number, userName?: string) => Promise<void>;
  showResponsibleUsersSkeletonLoader?: boolean;
}
